import { render, staticRenderFns } from "./Publicar.vue?vue&type=template&id=2f0b82f9&scoped=true"
import script from "./Publicar.vue?vue&type=script&lang=js"
export * from "./Publicar.vue?vue&type=script&lang=js"
import style0 from "./Publicar.vue?vue&type=style&index=0&id=2f0b82f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b82f9",
  null
  
)

export default component.exports